import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentEmi } from 'shared/config/store/selectors/app';
import { Button, ButtonProps, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { AddAccountDrawer } from './AddAccountDrawer';
import { RoundContainer } from 'shared/ui';
import { useIntl } from 'react-intl';
import classes from './AddAccount.module.scss';

type OwnProps = {
  type?: 'icon' | 'button' | 'container';
  label?: string;
};

type Props = OwnProps & Omit<ButtonProps, 'type'>;

const AddAccount: React.FC<Props> = ({ type = 'icon', label, ...buttonProps }) => {
  const [open, setOpen] = useState(false);
  const emi = useSelector(getCurrentEmi);
  const { formatMessage: t } = useIntl();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  let content: React.ReactNode;

  if (type === 'icon') {
    content = (
      <RoundContainer size={24} onClick={handleOpen}>
        <PlusOutlined style={{ fontSize: 20 }} />
      </RoundContainer>
    );
  }

  if (type === 'button') {
    content = (
      <Button
        onClick={handleOpen}
        type="text"
        style={{ width: '100%', backgroundColor: 'white' }}
        {...buttonProps}>
        {label || t({ id: 'addAccount.openAccount' })}
      </Button>
    );
  }

  if (type === 'container') {
    content = (
      <div className={classes.addAccountContainer} onClick={handleOpen}>
        <PlusOutlined className={classes.addIcon} />
        <Typography.Text className={classes.addText}>{ t({ id: 'account.addAccount.add' }) }</Typography.Text>
      </div>
    );
  }

  return (
    <>
      {content}
      <AddAccountDrawer open={open} onClose={handleClose} emi={emi} />
    </>
  );
};

export default AddAccount;
